import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

// menu item imports
import { addApplianceMenuItem } from '../menu-item/add-appliance-menu-item';
import { addApplianceSkuLayerMenuItem } from '../menu-item/add-appliance-sku-layer-menu-item';
import { addCustomApplianceMenuItem } from '../menu-item/add-custom-appliance-menu-item';
import { addCutoutMenuItem } from '../menu-item/add-cutout-menu-item';
import { addSpacerMenuItem } from '../menu-item/add-spacer-menu-item';
import { connectionPropertiesMenuItem } from '../menu-item/connection-properties-menu-item';
import { distributeGroupsHorizonticallyMenuItem } from '../menu-item/distribute-groups-horizontally-menu-item';
import { editIslandMenuItem } from '../menu-item/edit-island-menu-item';
import { insertBreakpointMenuItem } from '../menu-item/insert-breakpoint-menu-item';
import { islandPropertiesMenuItem } from '../menu-item/island-properties-menu-item';
import { newIslandMenuItem } from '../menu-item/new-island-menu-item';

export const panelMenuList: Array<ContextMenuList> = [
	editIslandMenuItem(),
	newIslandMenuItem(),
	addApplianceMenuItem(),
	addApplianceSkuLayerMenuItem(),
	addCustomApplianceMenuItem(),
	addCutoutMenuItem(),
	addSpacerMenuItem(),
	insertBreakpointMenuItem(),
	distributeGroupsHorizonticallyMenuItem(),
	// downloadDxfMenuItem(),
	// deleteIslandMenuItem(),
	{ type: ContextMenuListItemType.Divider },
	connectionPropertiesMenuItem(),
	// panelPropertiesMenuItem(),
	islandPropertiesMenuItem()
];
